import { Statement } from "../../types"
import { Icon } from "source/shared/components"
import { Heading } from "@planningcenter/doxy-web"
import pluralize from "source/shared/pluralize"
import { css } from "@emotion/react"
import { formattedCents } from "source/giving/utils/money"
import { dateStampStringToLocal } from "source/giving/donate/form/utils/frequency"

type StatementDetailsProps = {
  statement: Statement
}

export default function StatementDetails({ statement }: StatementDetailsProps) {
  return (
    <div className="action-drawer d-f br-8p jc-sb g-1 mb-2">
      <div className="w-100%">
        <div className="d-f fd-c fd-r@sm g-4p g-1@sm ai-fs jc-sb">
          <Heading
            level={2}
            size={4}
            isUppercase={true}
            text={statement.name}
            color="tint1"
          />
          <span className="fs-13 c-tint1 fw-600 ws-nw mt-1p">
            {dateStampStringToLocal(statement.starts_on)} -{" "}
            {dateStampStringToLocal(statement.ends_on)}
          </span>
        </div>
        <div>
          <span className="fs-13 c-tint2 fw-500">
            {pluralize(statement.donation_count, "Donation")}{" "}
            {formattedCents(statement.amount_cents, {
              noCentsIfWhole: false,
            })}
          </span>
        </div>
      </div>
      <a
        href={statement.download_url}
        aria-label="Download this statement"
        className="clickable-icon"
        css={css`
          padding: 3px 8px !important;
        `}
      >
        <Icon symbol="general#thick-to-bottom-arrow" aria-hidden="true" />
      </a>
    </div>
  )
}
